var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlipBackward0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13677 4.30409C5.39712 4.04374 5.39712 3.62163 5.13677 3.36128C4.87642 3.10093 4.45431 3.10093 4.19396 3.36128L1.52729 6.02794C1.26694 6.28829 1.26694 6.7104 1.52729 6.97075L4.19396 9.63742C4.45431 9.89777 4.87642 9.89777 5.13677 9.63742C5.39712 9.37707 5.39712 8.95496 5.13677 8.69461L3.60817 7.16602H10.9987C12.2874 7.16602 13.332 8.21068 13.332 9.49935C13.332 10.788 12.2874 11.8327 10.9987 11.8327H7.9987C7.63051 11.8327 7.33203 12.1312 7.33203 12.4993C7.33203 12.8675 7.63051 13.166 7.9987 13.166H10.9987C13.0237 13.166 14.6654 11.5244 14.6654 9.49935C14.6654 7.47431 13.0237 5.83268 10.9987 5.83268H3.60817L5.13677 4.30409Z",
    fill: "#4F5B6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipBackward0);
export default __webpack_public_path__ + "static/media/flip-backward0.99e39a37d692ffd9f39b2bb8c55ef355.svg";
export { ForwardRef as ReactComponent };